/**
 * Name prefix of the temporary file a new or updated file is written to before it’s renamed to its
 * final name. See {@link saveFile}.
 */
export const TEMP_FILE_PREFIX = '.sveltia-tmp-';
